import React, {Component} from 'react';
import AppNavigation from './AppNavigation';
import AppFooter from './AppFooter';
import SubGroupDetails from './Subcomponents/GroupDetails';
import withRouter from './Functions/WithRouter';

class AdvGroupDetails extends Component {
    constructor(props) {
      super(props)

      this.state = {
      }

      this.loadWorkspace = this.loadWorkspace.bind(this)
    }

    componentDidMount(){
      document.body.style.backgroundColor = "rgba(178,186,191,0.2)";

      let email = localStorage.getItem('email');
      let roleName = localStorage.getItem('roleName');
      let orgFocus = localStorage.getItem('orgFocus');
      let username = localStorage.getItem('username');
      let activeOrg = localStorage.getItem('activeOrg');
      const orgLogo = localStorage.getItem('orgLogo');

      let groupId = null
      let selectedGroup = null
      if (this.props.params) {
        console.log('went directly to posting')
        groupId = this.props.params.groupId

      } else {
        selectedGroup = this.props.location.state.selectedGroup
        groupId = this.props.location.state.objectId
      }

      this.setState({ groupId, selectedGroup, activeOrg, emailId: email, username,
        orgFocus, roleName, orgLogo
      })

      if (window.innerWidth > 768) {

        setTimeout(() => {
            this.setState(state => ({
                opacity: 1,
                transform: 'translate(2%)'
              }));
        }, 0.3)

      } else {

        setTimeout(() => {
            this.setState(state => ({
                opacity: 1,
                transform: 'translate(2%)'
              }));
        }, 0.3)
      }
    }

    componentDidUpdate(prevProps) {
        console.log('componentDidUpdate called within parentGroupDetails ', this.props, prevProps)

      if (this.props.params && this.props.params.groupId !== prevProps.params.groupId) {
        // console.log('new group selected in parent', this.props.params.groupId)
        let selectedGroup = this.props.location.state
        if (this.props.location && this.props.location.state && this.props.location.state.selectedGroup) {
          selectedGroup = this.props.location.state.selectedGroup
        }
        this.setState({ groupId: this.props.params.groupId, selectedGroup })
      }
    }

    loadWorkspace(activeOrg) {
      console.log('loadWorkspace called', activeOrg)

      this.setState({ activeOrg })

    }

    render() {

      return (
        <div>
          <AppNavigation username={this.state.username} fromAdvisor={true} activeOrg={this.state.activeOrg} orgFocus={this.state.orgFocus} roleName={this.state.roleName} history={this.props.navigate} />

          <div>
            <SubGroupDetails selectedGroup={this.state.selectedGroup} groupId={this.state.groupId} history={this.props.navigate} />
          </div>

          {(this.state.activeOrg) && (
            <div>
              {AppFooter(this.props.navigate,this.state.activeOrg,this.state.orgLogo)}
            </div>
          )}

        </div>
      )
    }
}

export default withRouter(AdvGroupDetails);
